module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "medium-12"
  }, [(!_vm.isCorporate) ? _c('div', {
    staticClass: "margin-b-xs"
  }, [_c('label', {
    staticClass: "field-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guestChecked),
      expression: "guestChecked"
    }, {
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "checkbox",
    staticClass: "margin-r-xs",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.guestChecked) ? _vm._i(_vm.guestChecked, null) > -1 : (_vm.guestChecked)
    },
    on: {
      "click": _vm.showHideForm,
      "change": _vm.updateGuestInfo,
      "__c": function($event) {
        var $$a = _vm.guestChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.guestChecked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.guestChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.guestChecked = $$c
        }
      }
    }
  }), _vm._v(" "), (!_vm.isHidden) ? _c('i', {
    staticClass: "fas fa-check-square chkbox fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n      " + _vm._s(_vm.$t('customerForm.bookForSomeone')) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "GuestForm",
    class: ['guest-form showhide-fadeslide', (_vm.isHidden ? 'hide' : ''), (_vm.isCorporate ? 'is-corporate' : '')]
  }, [_c('form', {
    class: ['padding-a-m', _vm.isSafari],
    attrs: {
      "action": "#",
      "data-vv-scope": "guest-form"
    }
  }, [_c('h3', {
    staticClass: "margin-t-z margin-b-s"
  }, [_vm._v(_vm._s(_vm.$t('customerForm.paxInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-6 column padding-r-s small-padding-h-z"
  }, [_c('div', {
    class: ['field-group', {
      'field-error': _vm.error.firstName
    }]
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('customerForm.firstName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    ref: "firstName",
    staticClass: "field-text",
    attrs: {
      "type": "text",
      "name": "fname",
      "placeholder": "John"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "change": _vm.updateGuestInfo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.firstName),
      expression: "error.firstName"
    }],
    staticClass: "field-error-message"
  }, [_vm._v(_vm._s(_vm.error.firstName))])])]), _vm._v(" "), _c('div', {
    staticClass: "medium-6 columns padding-l-s small-padding-h-z"
  }, [_c('div', {
    class: ['field-group', {
      'field-error': _vm.error.lastName
    }]
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('customerForm.lastName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "field-text",
    attrs: {
      "type": "text",
      "name": "lname",
      "placeholder": "Doe"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "change": _vm.updateGuestInfo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.lastName),
      expression: "error.lastName"
    }],
    staticClass: "field-error-message"
  }, [_vm._v(_vm._s(_vm.error.lastName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-12 columns"
  }, [_c('mobile-input', {
    ref: "guestMobile",
    attrs: {
      "mobile": _vm.mobile,
      "isGuest": true,
      "needVerification": false,
      "required": _vm.mobileRequired
    },
    on: {
      "updateMobile": _vm.updateGuestInfo,
      "guestMobileValidate": _vm.guestMobileValidate
    }
  })], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66ba43fc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66ba43fc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/GuestForm.vue
// module id = 2105
// module chunks = 0